module.exports = __webpack_public_path__ + "static/img/3919_phase_function_Paper_PointsHejduk_Prediction.2c5d689.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3919_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 9xCk
// module chunks = 0